import Router from 'next/router'
import { resolveHref } from 'next/dist/shared/lib/router/router'
import { RouteMap, RouteMapKeys } from '~/lib/routeMap'

export type QueryParams = { [key: string]: string | number }

// https://github.com/vercel/next.js/discussions/22025
export const getRouteLink = (routeName: RouteMapKeys, query?: QueryParams | null) => {
  let pathname = RouteMap[routeName]

  const [, resolvedAs] = resolveHref(Router, { pathname, query }, true)

  return resolvedAs
}
